module.exports = __webpack_public_path__ + "static/media/6.0 telegram-final-stickers gif.f04a85d2.gif";